import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormHelper } from '@app/shared/helpers/form';
import { IPasswordRestore } from '@app/modules/auth/interface/password-restore';
import {customEmailValidator} from '@app/shared/validators/email';

@Component({
  selector: 'app-password-restore-form',
  templateUrl: './password-restore-form.component.html'
})
export class PasswordRestoreFormComponent implements OnInit {
  @Output() public submitEvent = new EventEmitter<IPasswordRestore>();

  public form: FormGroup;

  public get username(): FormControl {
    return this.form.get('username') as FormControl;
  }

  constructor(
    private readonly fb: FormBuilder
  ) {}

  public ngOnInit(): void {
    this.createForm();
  }

  public submit(): void {
    FormHelper.markAllAsDirty(this.form);

    if (this.form.valid) {
      this.submitEvent.emit(this.form.value);
    }
  }

  public getErrorMessage(key: string, control: FormControl): string {
    return FormHelper.getErrorMessage(key, control);
  }

  private createForm(): void {
    this.form = this.fb.group({
      username: ['', [
        customEmailValidator(),
        Validators.required
      ]]
    });

    // Removed reCAPTCHA control
  }
}
